export var TEXT_PLAIN = "text/plain";
export var TEXT_HTML = "text/html";
